import React, { useState, useEffect } from "react";
import { aboutBg, services41 } from "../../../../assets/images"; // Örnek görsel eklendi
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Directional = () => {
  const { t } = useTranslation();

  const [heroHeight, setHeroHeight] = useState("300px");

  useEffect(() => {
    const updateHeight = () => {
      setHeroHeight(window.innerWidth < 640 ? "200px" : "300px");
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <>
      {/* Hero Section */}
      <div
        className="relative bg-black/60 w-full"
        style={{
          backgroundImage: `url(${aboutBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: heroHeight,
        }}
      >
        <SubOtherHero title="Directional drilling" />
      </div>

      {/* Content Section */}
      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="md:max-w-container max-w-containerSm mx-auto md:flex md:items-start md:justify-between gap-10">
          {/* Left Content */}
          <div className="md:w-2/3">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t("Directional drilling")}
            </p>

            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "Caspian Rock Solutions has wide experience in the Directional Drilling with use of high-tech equipment from leading manufacturers, as well as with use of rotary-steerable systems in the drilling of horizontal trunks of 1500 and more meters length in the fields with AHRP (abnormally high reservoir pressure). We provide a full range of equipment for MWD, LWD, Motors and RSS. We have drilled more than 65 wells in the last 2 years."
              )}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "We use the DD service on the projects of Guneshli and Western Absheron off shore and Garadagh, Pirallahi and Chilov Island on shore projects in Azerbaijan."
              )}
            </p>
          </div>

          {/* Right Image */}
          <div className="mt-8 md:mt-0 md:w-1/3">
            <img
              src={services41}
              alt="Service Illustration"
              className="w-full rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Directional;
